/**
 * Refinement style types and constants
 */

export interface PresetStyle {
  id: string;
  name: string;
  prompt: string;
  isPreset: true;
}

export interface CustomStyle {
  id: string;
  name: string;
  prompt: string;
  isPreset: false;
  createdAt: number;
}

export type RefinementStyle = PresetStyle | CustomStyle;

export const PRESET_STYLES: PresetStyle[] = [
  {
    id: 'professional',
    name: 'Professional',
    prompt:
      'Refine this text to be clear, professional, and well-structured. Fix any grammar or spelling errors. Make it suitable for business communication. Return only the refined text in the same language as the input, with no introduction, explanation, or additional commentary.',
    isPreset: true,
  },
  {
    id: 'casual',
    name: 'Casual',
    prompt:
      "Refine this text to sound natural and conversational. Keep it friendly and approachable while fixing grammar. Don't make it too formal. Return only the refined text in the same language as the input, with no introduction, explanation, or additional commentary.",
    isPreset: true,
  },
  {
    id: 'technical',
    name: 'Technical',
    prompt:
      'Refine this text for technical accuracy and clarity. Use precise terminology, maintain technical details, and structure it logically for a technical audience. Return only the refined text in the same language as the input, with no introduction, explanation, or additional commentary.',
    isPreset: true,
  },
  {
    id: 'concise',
    name: 'Concise',
    prompt:
      'Refine this text to be as brief and concise as possible while preserving the core message. Remove unnecessary words and get straight to the point. Return only the refined text in the same language as the input, with no introduction, explanation, or additional commentary.',
    isPreset: true,
  },
  {
    id: 'friendly',
    name: 'Friendly',
    prompt:
      'Refine this text to sound warm, friendly, and engaging. Make it personal and approachable while maintaining clarity and fixing any errors. Return only the refined text in the same language as the input, with no introduction, explanation, or additional commentary.',
    isPreset: true,
  },
];

export const MAX_CUSTOM_PROMPTS = 10;
export const MIN_PROMPT_LENGTH = 10;
export const MAX_PROMPT_LENGTH = 500;
